module.exports = function( $scope, $ ) {
	var defaultActiveTab = $scope.find( '.kitbuilder-tabs' ).data( 'active-tab' ),
		$tabsTitles = $scope.find( '.kitbuilder-tab-title' ),
		$tabs = $scope.find( '.kitbuilder-tab-content' ),
		$active,
		$content;

	if ( ! defaultActiveTab ) {
		defaultActiveTab = 1;
	}

	var activateTab = function( tabIndex ) {
		if ( $active ) {
			$active.removeClass( 'active' );

			$content.hide();
		}

		$active = $tabsTitles.filter( '[data-tab="' + tabIndex + '"]' );

		$active.addClass( 'active' );

		$content = $tabs.filter( '[data-tab="' + tabIndex + '"]' );

		$content.show();
	};

	activateTab( defaultActiveTab );

	$tabsTitles.on( 'click', function() {
		activateTab( this.dataset.tab );
	} );
};
